import { render, staticRenderFns } from "./prestoreTransfer.vue?vue&type=template&id=a5bae644"
import script from "./prestoreTransfer.vue?vue&type=script&lang=js"
export * from "./prestoreTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports